import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gk-payment-end-simple-info',
  templateUrl: './payment-end-simple-info.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class PaymentEndSimpleInfoComponent {}
